<script>
  import TextField from 'smelte/src/components/TextField/TextField.svelte'
  import DatePicker from './DatePicker.svelte'
  import Icon from 'smelte/src/components/Icon/Icon.svelte'
  import { onMount } from 'svelte'

  export let filter = {}
  export let fk = ''
  export let dates = {}
  export let open = false

  $: menuItems = filter.search
    ? filter.search.filter(p => filter.value === '' || p.indexOf(filter.value) > -1)
    : []

  onMount(() => {
    // console.log('[DEBUG] filterInput:', fk, filter.label, filter)
  })

  function clearFieldHandler () {
    filter.value = ''
    if (filter.range_list) {
      filter.min_value = ''
      filter.max_value = ''
    }
    if (dates.hasOwnProperty(fk)) {
      dates[fk] = ''
    }
  }

  function datePickerHandler (date, fk) {
    filter.value = date.toISOString().slice(0, 11)
  }

  function clearDatePickerHandler (event, fk) {
    filter.value = ''
    dates[fk] = ''
  }
</script>

{#if filter.range_list}
  <TextField noUnderline
             bind:value={filter.min_value}
             label={'from'}
             append="clear"
             iconClass="text-gray-400 cursor-pointer"
             on:click-append={() => clearFieldHandler(fk)}
  />
  <TextField noUnderline
             bind:value={filter.max_value}
             label={'to'}
             append="clear"
             iconClass="text-gray-400 cursor-pointer"
             on:click-append={() => clearFieldHandler(fk)}
  />

{:else if filter.date}
  <div class="mb-6 relative">
    <DatePicker
      bind:displayValue={dates[fk]}
      label={filter.label}
      on:change={(event) => datePickerHandler(event.detail, fk)}
    />
    <div class="absolute text-gray-400 cursor-pointer" style="top: 1em; right: 3em"
         on:click={(event) => clearDatePickerHandler(event, fk)}
    >
      <Icon>close</Icon>
    </div>
  </div>
{:else if filter.type === 'number'}
  <TextField noUnderline
             bind:value={filter.value}
             label={filter.label}
             append="clear"
             iconClass="text-gray-400 cursor-pointer"
             on:click-append={() => clearFieldHandler(fk)}
  />
<!--{:else if filters[fk].search}-->
<!--  <Menu listClasses="absolute w-full top-12 bg-white left-0 bg-white shadow z-20"-->
<!--        items={menuItems}-->
<!--        open={menuItems.length > 0}-->
<!--        bind:value={filters[fk].value}-->
<!--  >-->
<!--    <div slot="activator">-->
<!--      <TextField noUnderline-->
<!--                 bind:value={filters[fk].value}-->
<!--                 label={filters[fk].label}-->
<!--                 append="clear"-->
<!--                 iconClass="text-gray-400 cursor-pointer"-->
<!--                 on:keyup={() => { open = true }}-->
<!--                 on:click-append={() => clearFieldHandler(fk)}-->
<!--      />-->
<!--    </div>-->
<!--  </Menu>-->
{:else}
  <TextField noUnderline
             bind:value={filter.value}
             label={filter.label}
             append="clear"
             iconClass="text-gray-400 cursor-pointer"
             on:click-append={() => clearFieldHandler(fk)}
  />
{/if}
